import {createRouter, createWebHistory} from "vue-router";
import routes from "./routes";
import {authMiddleware} from "./middlewares/authMiddleware";
import {sawTutorialMiddleware} from "@/routes/middlewares/sawTutorialMiddleware";
import {useUserInfo} from "@/composables/useUserInfo";

window.popStateDetected = false
window.addEventListener('popstate', () => {
    window.popStateDetected = true
})

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior: (to) => {
        const {isLegacyTheme} = useUserInfo()
        if (to.hash) {
            return {
                el: to.hash,
                behavior: "smooth",
            };
        } else if(isLegacyTheme(to.name)) {
            return {top: 0};
        }
    },
});

router.beforeEach(authMiddleware)
router.beforeEach(sawTutorialMiddleware)
router.beforeEach((to, from) => {
    const IsItABackButton = window.popStateDetected
    window.popStateDetected = false
    return !(IsItABackButton && from.name === 'schedule');
})

export default router;
